import { loadStripe } from '@stripe/stripe-js'

export const stripePromise = loadStripe('pk_test_51JbcHqLb7zblkbN2XlCqMJcq688FRrjt6nl62Pdrs7vYq9EDeY7hB4d6VKrGsMPljRO49mmd2VUJ3LB5NC7AYcN600MlAThhkR')

